export default __webpack_public_path__ + "static/media/issue-alert.9ba9058b.svg";